import React from "react";

export interface BridgeBarSettings {
  solutionGroupCode: string;
  sessionId: string;
  env: string;
}

export interface CoreBridgeBarProps {
  settings?: BridgeBarSettings;
}

export const CoreBridgeBar: React.FC<CoreBridgeBarProps> = ({ settings }) => {
  return React.createElement("bridge-bar", { settings });
};
